import Vue from 'vue';
import { mediaQueriesMixin } from '@/mixins';

export enum SpaceArea {
    A = 'A',
    B = 'B',
    C = 'C',
}

export enum Page {
    CategoryPage = 'CategoryPage',
    ReviewPage = 'ReviewPage',
    ComparisonPage = 'ComparisonPage',
    ArticleListPage = 'ArticleListPage',
    ArticlePage = 'ArticlePage',
}

export type DynamicComponent = {
    props: object;
    shouldShow: boolean;
    name?: string;
};

export const flexibleSpaceMixin = Vue.extend({
    mixins: [mediaQueriesMixin],
    methods: {
        getSpaceStoryState(page: Page, spaceArea: SpaceArea): string[] {
            const device = this.isMobileDevice() ? 'Mobile' : 'Desktop';
            const space = 'space' + spaceArea + device;
            return this.$globalConstants.components[page]?.[space] || [];
        },
        getActiveComponents(
            page: Page,
            spaceArea: SpaceArea,
            dynamicComponents: DynamicComponent[]
        ): DynamicComponent[] {
            return this.getSpaceStoryState(page, spaceArea)
                .map((componentName) => ({
                    ...dynamicComponents[componentName],
                    name: componentName,
                }))
                .filter((component) => component.shouldShow);
        },
    },
});
